import React from "react";
import { useParams } from "react-router-dom";
import { MainHeader } from "../components/global/MainHeader";
import { SortedShopSection } from "../components/Shop/SortedShopSection";
import { Socials } from "../components/Home/Socials";
import { getAllDocuments } from "../firebase/firebaseCrud";
import { useCart } from "../context/cart-context";

const Shop = () => {
  let params = useParams();
  const { isLoading, setIsLoading } = useCart();

  const [products, setProducts] = React.useState([]);

  const [path, setPath] = React.useState("Shop");
  React.useEffect(() => {
    if (params.slug === "recently-added") {
      setPath("Recently Added");
    } else if (params.slug === "best-seller") {
      setPath("Best Seller");
    } else if (params.slug === "deluxe-collection") {
      setPath("Deluxe Collection");
    }
    // console.log("params slug:", params.slug);
    // console.log("path", path);
  }, [params, params.slug]);

  const getProducts = async () => {
    const prods = await getAllDocuments("product-list");
    setProducts(prods);
  };

  React.useEffect(() => {
    getProducts();
  }, []);

  // console.log("Shop products", products);

  React.useEffect(() => {
    if (products.length <= 0) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [products]);

  return (
    <React.Fragment>
      <MainHeader name={path} />
      <SortedShopSection data={products} />
      <Socials imgSrc={"../SBD/StrandsHairs.png"} />
    </React.Fragment>
  );
};

export default Shop;
